import React from 'react';
import _ from 'lodash';
import type OrderItem from '@this/domain/order_item2';
import type { Element } from '@this/domain/order_item2';
import HotelElement from '@this/domain/hotel_element2';
import InAdvanceApplicationOrderItemDetailLine from './in_advance_application_order_item_detail_line';

interface TripDescriptionContentProps {
  el: Element;
  firstEl?: Element;
  orderItem?: OrderItem;
  elementIndex?: number;
  isPackage: boolean;
  flightPriceChangeDetail: string;
}

const TripDescriptionContent = ({
  el,
  firstEl,
  orderItem,
  elementIndex,
  isPackage,
  flightPriceChangeDetail
}: TripDescriptionContentProps) => {
  return (
    <div>
      {el.name && <div style={{ fontWeight: 'bold' }}>{el.name}</div>}
      <div data-wovn-ignore>
        {el.summary.split('\n').map((line: string, i: number) => {
          const prevLine = firstEl ? firstEl.summary.split('\n')[i] : '';
          if (_.isEmpty(prevLine) || prevLine === line) {
            return <p key={i}>{_.isEmpty(line) ? <br /> : line}</p>;
          }
          return (
            <React.Fragment key={i}>
              <p style={{ textDecoration: 'line-through', textDecorationColor: '#a72c09' }}>
                {_.isEmpty(prevLine) ? <br /> : prevLine}
              </p>
              <p style={{ color: '#a72c09' }}>{_.isEmpty(line) ? <br /> : line}</p>
            </React.Fragment>
          );
        })}
      </div>
      {flightPriceChangeDetail && <p>{flightPriceChangeDetail}</p>}
      {orderItem && (
        <div data-wovn-ignore>
          {el
            .detail(orderItem, { inlineRestricted: true, elementIndex })
            .split('\n')
            .map((line: string, i: number) => {
              const prevLine =
                firstEl && orderItem.firstItem
                  ? firstEl.detail(orderItem.firstItem, { inlineRestricted: true, elementIndex }).split('\n')[i]
                  : '';
              return (
                <InAdvanceApplicationOrderItemDetailLine
                  line={line}
                  prevLine={prevLine}
                  key={`${orderItem.id}-${i}`}
                />
              );
            })}
        </div>
      )}
      {el instanceof HotelElement && !isPackage && el.detailPath && (
        <div>
          <span>宿泊詳細情報：</span>
          <span>
            <a href={el.detailPath} target="_blank" rel="noreferrer noopener">
              詳細はコチラ
            </a>
          </span>
        </div>
      )}
    </div>
  );
};

export default TripDescriptionContent;
